module.exports = __webpack_public_path__ + "img/f3974db1c424e32bb61821a7dba03c8a.png";